import { ComponentProps, forwardRef } from "react";
import { twMerge } from "tailwind-merge";
import { LabelBase } from "@core/ui";
import { Type, TypeVariant } from "../Type";

type LabelProps = ComponentProps<"label"> & {
  variant?: "default" | "error";
  required?: boolean;
  error?: boolean;
  id?: string;
  typeVariant?: TypeVariant;
};

export type Props = LabelProps;

export const Label = forwardRef<HTMLLabelElement, Props>(
  (
    {
      className,
      variant,
      required = false,
      error,
      id,
      children,
      typeVariant = "caption",
      ...props
    },
    ref
  ) => (
    <LabelBase
      ref={ref}
      as={Type}
      variant={typeVariant}
      id={id}
      required={required}
      error={error}
      className={twMerge(
        "text-brand-700 font-medium peer-disabled:cursor-not-allowed peer-disabled:text-brand-300",
        variant === "error" && "text-error",
        error && "text-error-600",
        className
      )}
      renderRequired={() => <span className="text-error ml-0.5">*</span>}
      {...props}
    >
      {children}
    </LabelBase>
  )
);

Label.displayName = "Label";

export default Label;

